import { addUserGroupMember, deleteUserGroupMember } from 'services'

export const handleGroupMembersChange = (groupId, initialMembersIds, selectedMembersIds) => {
  const memberIdsToAdd = selectedMembersIds.filter(selectedId => !initialMembersIds.includes(selectedId))
  const memberIdsToRemove = initialMembersIds.filter(initialId => !selectedMembersIds.includes(initialId))
  return Promise.all([
    ...memberIdsToAdd.map(userId => addUserGroupMember(groupId, { userId })),
    ...memberIdsToRemove.map(userId => deleteUserGroupMember(groupId, userId))
  ])
}
